import {HttpRenewTransformProjectOptions, httpRenewTransformProject} from '@/features/projects/http/projects.http'
import {ProjectSmall} from '@/features/projects/types'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreRenewTransformProject = ({
    projectId,
    options
}: {
    projectId: string
    options?: UseMutationOptions<
        Omit<ProjectSmall, 'referringDoctor' | 'progressStatus'>, // todo: remove this omit once the backend is updated
        AxiosError<ErrorResponseData>,
        HttpRenewTransformProjectOptions['payload']
    >
}) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.RENEW_TRANSFORM_PROJECT, projectId],
        mutationFn: payload => httpRenewTransformProject({urlParams: {projectId}, payload}),
        // Renew, extend, transform, resume, reopen and variation all move the patient onto a different
        // project, so the project lookups of the medical record report flow (the by-date lookup and the
        // project select) must not keep answering with the pre-operation projects.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS_BY_PATIENT]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
